import { useState } from 'react';

export const useRequestsLoaderState = () =>
  useState({
    isUserLoading: true,
    isSchoolSettingsLoading: true,
    isTranslationLoading: true,
    isUserSettingsLoading: true,
  });
